import React from 'react';
import { CM2Dataset, DatasetFilter } from '@interfaces/central-monitoring';

export interface IDatasetFilters {
    dataSetFilter: number | null | undefined;
    dataSetsCount: DatasetFilter | null | undefined;
    comparisonDataset?: CM2Dataset | null;
}

export interface IDataset {
    id: number;
    date: Date;
}

export interface IFormData {
    studyRef: string;
    dataset?: IDataset | null | undefined;
    hidePanelSetup: boolean;
    defaultDatasetFilters: IDatasetFilters;
    datasetFilters: IDatasetFilters;
    siteId?: number;
    siteCode?: string;
    siteName?: string;
}

interface IContext {
    current: IFormData;
    setCurrent: React.Dispatch<React.SetStateAction<IFormData>>;
    setComparisonDataset: React.Dispatch<React.SetStateAction<CM2Dataset | undefined>>;
    setSiteId?: React.Dispatch<React.SetStateAction<number | undefined>>;
    setSiteName?: React.Dispatch<React.SetStateAction<string | undefined>>;
}

interface ISMContext {
    current: ISMFormData;
    setCurrent: React.Dispatch<React.SetStateAction<ISMFormData>>;
}

export const StudySiteHubContext = React.createContext<IContext>(undefined!);
export const SubjectMonitoringContext = React.createContext<ISMContext>(undefined!);

export interface ISMDataset {
    id: number;
    created: Date;
    dataCutDate: Date;
}

export interface ISMFormData {
    studyRef: string;
    dataset: ISMDataset;
    subjectId?: number;
    subjectCode?: string;
    subjectNumber?: string;
}
